import type { IBridgeRepositoryProduct } from '@skystone/shared';
import { bridgeRepoProductApi } from '@/services/bridge-repo-product-api';
import { useApi } from '@/hooks/useApi';
import { DataTable, ErrorBanner, PageHeader, PageLoading } from '@/components/ui';
import type { ColumnDef } from '@/components/ui';
import { buildRawColumns, buildStandardEmptyMessage, buildStandardTblSubtitle } from '@/lib/tbl-page-utils';
import { PageContainer } from '@/components/layout';

const bridgeColumns: ColumnDef<IBridgeRepositoryProduct>[] = buildRawColumns<IBridgeRepositoryProduct>([
  { key: 'id', header: 'ID' },
  { key: 'repositoryName', header: 'Repository Name' },
  { key: 'productName', header: 'Product Name' },
  { key: 'fabricRepositoryKey', header: 'Fabric Repository Key' },
  { key: 'fabricProductKey', header: 'Fabric Product Key' },
  { key: 'fabricSynced', header: 'Fabric Synced' },
  { key: 'fabricSyncedAt', header: 'Fabric Synced At' },
  { key: 'createdAt', header: 'Created At' },
  { key: 'updatedAt', header: 'Updated At' },
]);

export function TblBridgeRepositoryProductPage() {
  const { data: rows, loading, error } = useApi(() => bridgeRepoProductApi.getAll(), []);

  if (loading && !rows) {
    return <PageLoading />;
  }

  return (
    <PageContainer variant="wide" className="space-y-6">
      <PageHeader title="Tbl - bridge_repository_product" subtitle={buildStandardTblSubtitle()} />
      <ErrorBanner message={error} />
      <DataTable
        data={rows ?? []}
        columns={bridgeColumns}
        keyExtractor={(row) => row.id}
        enablePagination
        enableFilters
        emptyMessage={buildStandardEmptyMessage('bridge_repository_product')}
      />
    </PageContainer>
  );
}
